import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Wallet = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [aletaMemberNo, setAletaMemberNo] = useState("");
  const [aletaAccountNo, setAletaAccountNo] = useState("");
  const [aletaAccountSerialNo, setAletaAccountSerialNo] = useState("");

  const userID = localStorage.getItem("userID");
  const userName = localStorage.getItem("username");

  const containerStyle = useMemo(
    () => ({
      minHeight: "100vh",
      backgroundColor: "black",
      padding: "20px",
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
    }),
    [],
  );

  const cardStyle = useMemo(
    () => ({
      width: "100%",
      maxWidth: "520px",
      borderRadius: "10px",
      border: "1px solid #DFBD69",
      backgroundColor: "#111",
      padding: "22px",
      color: "#DFBD69",
    }),
    [],
  );

  const buttonStyle = useMemo(
    () => ({
      backgroundColor: "#DFBD69",
      color: "black",
      border: "none",
      borderRadius: "8px",
      padding: "10px 14px",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: 600,
    }),
    [],
  );

  const smallButtonStyle = useMemo(
    () => ({
      ...buttonStyle,
      padding: "8px 10px",
      fontSize: "13px",
      fontWeight: 600,
    }),
    [buttonStyle],
  );

  const fetchAletaDetails = useCallback(async () => {
    if (!userID || !userName) {
      setError("Please log in to view your wallet details.");
      return;
    }

    setLoading(true);
    setError("");
    try {
      const langId = localStorage.getItem("languageId") || "2224";
      const response = await fetch(
        "https://xianhefairy.com/LotusFairy_API/api/User/GetProfile",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            UserName: userName,
            ID: userID,
            LangId: parseInt(langId, 10),
            UserToken: "",
            Token: {
              AccessToken:
                "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
            },
          }),
        },
      );

      const result = await response.json();
      if (!response.ok || !result?.Profiles?.[0]) {
        throw new Error(result?.Message || result?.message || "Failed to load wallet details");
      }

      const profile = result.Profiles[0];
      setAletaMemberNo(profile.AletaMemberNo || "");
      setAletaAccountNo(profile.AletaAccountNo || "");
      setAletaAccountSerialNo(profile.AletaAccountSerialNo || "");
    } catch (e) {
      setError(e?.message || "Failed to load wallet details");
    } finally {
      setLoading(false);
    }
  }, [userID, userName]);

  useEffect(() => {
    const loggedIn = localStorage.getItem("isLoggedIn") === "true";
    if (!loggedIn) {
      navigate("/main", { replace: true });
      return;
    }
    fetchAletaDetails();
  }, [fetchAletaDetails, navigate]);

  const copyToClipboard = async (value) => {
    if (!value) return;
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(value);
      } else {
        const temp = document.createElement("textarea");
        temp.value = value;
        document.body.appendChild(temp);
        temp.select();
        document.execCommand("copy");
        document.body.removeChild(temp);
      }
    } catch {
      // ignore clipboard errors
    }
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "12px",
            marginBottom: "16px",
          }}
        >
          <h2 style={{ margin: 0, fontSize: "20px" }}>Aleta Wallet</h2>
          <button
            type="button"
            style={{
              ...smallButtonStyle,
              opacity: loading ? 0.6 : 1,
              cursor: loading ? "not-allowed" : "pointer",
            }}
            onClick={fetchAletaDetails}
            disabled={loading}
          >
            {loading ? "Loading..." : "Refresh"}
          </button>
        </div>

        {error && (
          <div style={{ color: "#ffb3b3", marginBottom: "14px" }}>{error}</div>
        )}

        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
            <div style={{ flex: 1, overflowWrap: "anywhere" }}>
              <div style={{ fontWeight: 700, marginBottom: "6px" }}>
                {t("account.aletaMemberNo", { defaultValue: "Aleta Member No" })}
              </div>
              <div style={{ color: "#DFBD69" }}>{aletaMemberNo || "-"}</div>
            </div>
            <button
              type="button"
              style={{ ...smallButtonStyle, minWidth: "74px" }}
              onClick={() => copyToClipboard(aletaMemberNo)}
              disabled={!aletaMemberNo}
            >
              Copy
            </button>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
            <div style={{ flex: 1, overflowWrap: "anywhere" }}>
              <div style={{ fontWeight: 700, marginBottom: "6px" }}>
                {t("account.aletaAccountNo", { defaultValue: "Aleta Account No" })}
              </div>
              <div style={{ color: "#DFBD69" }}>{aletaAccountNo || "-"}</div>
            </div>
            <button
              type="button"
              style={{ ...smallButtonStyle, minWidth: "74px" }}
              onClick={() => copyToClipboard(aletaAccountNo)}
              disabled={!aletaAccountNo}
            >
              Copy
            </button>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
            <div style={{ flex: 1, overflowWrap: "anywhere" }}>
              <div style={{ fontWeight: 700, marginBottom: "6px" }}>
                {t("account.aletaAccountSerialNo", {
                  defaultValue: "Aleta Account Serial No",
                })}
              </div>
              <div style={{ color: "#DFBD69" }}>{aletaAccountSerialNo || "-"}</div>
            </div>
            <button
              type="button"
              style={{ ...smallButtonStyle, minWidth: "74px" }}
              onClick={() => copyToClipboard(aletaAccountSerialNo)}
              disabled={!aletaAccountSerialNo}
            >
              Copy
            </button>
          </div>
        </div>

        <div style={{ marginTop: "18px", display: "flex", gap: "10px" }}>
          <button
            type="button"
            style={buttonStyle}
            onClick={() => navigate("/account", { state: { setactiveTab: "accountInfo" } })}
          >
            Back to Account
          </button>
        </div>
      </div>
    </div>
  );
};

export default Wallet;
